import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const vouchertemplates = {
    state: () => ({
        items: [],
        filter: {
            searchTerm: null,
            skip: 0,
            take: 200,
            total: 0,
            page: 1,
        },
        selectedItems: [],
        loading: true,
    }),
    mutations: {
        setVoucherTemplates(state, payload) {
            state.items = payload.items;
            state.filter.total = payload.total;
        },
        setSelectedVoucherTemplates(state, payload) {
            state.selectedItems = payload;
        },
        setVoucherTemplatePage(state, payload) {
            state.filter.page = payload;
            this.dispatch("getVoucherTemplates");
        },
        setVoucherTemplateTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
            this.dispatch("getVoucherTemplates");
        },
    },
    actions: {
        async getVoucherTemplates(store) {
            store.state.loading = true;
            await axios
                .post("voucherscheme/load", {
                    ...store.state.filter,
                    skip: (store.state.filter.page - 1) * store.state.filter.take,
                })
                .then((res) => {
                    store.state.loading = false;
                    return store.commit("setVoucherTemplates", res.data.data);
                });
        },
        async toggleVoucherTemplate(store, payload) {
            var res = await axios.post("voucherscheme/toggleisactive", {
                id: store.state.items[payload.index].id,
            });
            return res.data;
        },
        async deleteVoucherTemplate(store, payload) {
            await axios
                .post("voucherscheme/delete", {
                    id: store.state.items[payload.index].id,
                })
                .then((res) => {
                    if (res.data.alert.hasError) {
                        payload.context.$message.error(res.data.alert.message);
                    } else {
                        store.state.items.splice(payload.index, 1);
                        payload.context.$message.success(res.data.alert.message);

                        store.state.filter.total = store.state.filter.total - 1;
                    }
                });
        },
    },
    getters: {
        getVoucherList: (state) => state.items
    },
};
export default vouchertemplates;


// WEBPACK FOOTER //
// ./src/store/vouchertemplates.js